
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import DataFieldCache from "@/models/data.field.cache";
import {dataFieldsEditModule} from "@/store";
import {MdbsCore} from "@/api/tsclient";
import AuditReasonOfChangeDto = MdbsCore.AuditReasonOfChangeDto;
import {DEFINITIONTYPE_POPULATION} from "@/auxillary/rules";

@Component
export default class ChangedDataField extends Vue {
  @Prop({required: true}) dataFieldCache!: DataFieldCache;

  defaultReasons = ["Neue Information", "Dateneingabefehler", "Sonstiges"];
  populationReasons = ["Änderung des Ursprungswertes"];
  defaultReasonsWithPopulation = ["Neue Information", "Dateneingabefehler", "Änderung des Ursprungswertes", "Sonstiges"];
  reasonForChange = new AuditReasonOfChangeDto();

  @Watch('dataFieldCache', {immediate: true})
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async onDataFieldCacheChange(dataFieldCache: DataFieldCache) {
    if (this.isPopulated) {
      this.objectReason = this.populationReasons[0];
    }
  }

  get reasons() {
    if (this.isPopulated)
      return this.populationReasons;
    if (this.isPopulatedField)
      return this.defaultReasonsWithPopulation;
    return this.defaultReasons;
  }

  get objectReason() {
    return this.dataFieldCache?.reasonForChange?.objectReason;
  }

  set objectReason(value: string | undefined) {
    this.reasonForChange = new AuditReasonOfChangeDto();
    this.reasonForChange.objectReason = value;
    if (this.dataFieldCache)
      dataFieldsEditModule.setReasonForChange({
        field: this.dataFieldCache,
        reasonForChange: this.reasonForChange});
  }

  get isReadonlyField() {
    const isReadOnly = this.dataFieldCache.definitionType == "DisplayValue";
    return isReadOnly;
  }

  get isPopulatedField() {
    const isPopulatedField = this.dataFieldCache.rules.some(rule => rule.definitionType == DEFINITIONTYPE_POPULATION && !rule.isDeleted);
    return isPopulatedField;
  }

  get isPopulated() {
    if (this.isPopulatedField && this.isReadonlyField)
      return true;

    // TODO: find original field/value and compare if is user edited
    //const hasOriginalFieldId = this.dataFieldCache.tags?.originalFieldId != undefined && this.dataFieldCache.tags?.originalFieldId != "";
    //if(!hasOriginalFieldId) return false;

    return false;
  }
}
